import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import octagon from 'media/octagon.svg'

export default function OctagonBadge({ small, children }) {
  return (
    <div
      style={{ filter: 'drop-shadow(0 5px 5px rgba(0, 0, 0, 0.3))' }}
      data-uid="badge"
    >
      <div
        style={{
          display: 'inline-grid',
          gridTemplateColumns: 'min-content',
          transform: 'rotate(4deg)',
        }}
      >
        <img
          style={{ gridColumn: 1, gridRow: 1 }}
          src={octagon}
          alt=""
          className="w-full"
        />
        <div
          className={classNames(
            'text-white self-center',
            small
              ? 'type-14-bold lg:type-17-bold px-6 lg:px-8'
              : 'type-28-bold lg:type-32-bold px-12 lg:px-16'
          )}
          style={{ gridColumn: 1, gridRow: 1 }}
        >
          {children}
        </div>
      </div>
    </div>
  )
}

OctagonBadge.propTypes = {
  small: PropTypes.bool,
  children: PropTypes.node,
}
